import M from "materialize-css";

export class TopbarController {
    public static $inject: string[] = [
        "$state",
        "aclService",
        "sitesService"
    ];

    constructor(
        public $state: ng.ui.IStateService,
        public aclService,
        public sitesService
    ) {}

    public $onInit() {
        angular.element(document).ready(() => {
            const elems: NodeListOf<Element> = document.querySelectorAll(".sidenav-menu");
            M.Sidenav.init(elems, {});
        });
    }

    public openMenu() {
        angular.element(document).ready(() => {
            const elems: NodeListOf<Element> = document.querySelectorAll(".sidenav-menu");
            const sidenav = M.Sidenav.getInstance(elems[0]);
            sidenav.open();
        });
    }
}
